// src/components/Topbar.jsx
import { C } from "../styles/tokens";
import { Icon } from "./UI";

export default function Topbar({ title, subtitle, onMenu }) {
  return (
    <div
      style={{
        height: 60,
        background: C.card,
        borderBottom: `1px solid ${C.border}`,
        display: "flex",
        alignItems: "center",
        padding: "0 20px",
        gap: 14,
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      {/* Mobile menu button */}
      <button
        onClick={onMenu}
        style={{
          background: "none", border: "none", cursor: "pointer",
          color: C.muted, display: "flex", alignItems: "center",
        }}
      >
        <Icon name="menu" size={22} color={C.muted} />
      </button>

      {/* Title */}
      <div style={{ flex: 1 }}>
        <div className="syne" style={{ fontSize: 17, fontWeight: 800, color: C.text, lineHeight: 1 }}>
          {title}
        </div>
        {subtitle && (
          <div style={{ fontSize: 11, color: C.muted, marginTop: 2 }}>{subtitle}</div>
        )}
      </div>

      {/* Right actions */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {/* Notification bell */}
        <div style={{ position: "relative" }}>
          <button
            style={{
              background: C.card2,
              border: `1px solid ${C.border}`,
              width: 36, height: 36,
              borderRadius: 9,
              display: "flex", alignItems: "center", justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <Icon name="bell" size={17} color={C.muted} />
          </button>
          <div className="notif-dot" />
        </div>

        {/* Avatar */}
        <div
          style={{
            width: 36, height: 36,
            background: "rgba(198,40,40,.2)",
            borderRadius: 9,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <span style={{ color: C.red, fontSize: 13, fontWeight: 800 }}>DR</span>
        </div>
      </div>
    </div>
  );
}